import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaBus, FaArrowRight } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import { SCHEDULE_PATH, TRANSPORT_PATH } from '../config/externalLinks';
import './ParentsTools.css';

/** Sekcija "Za roditelje" — linkovi ka rasporedu treninga i organizaciji prevoza (Right Decision). */
const ParentsTools: React.FC = () => {
  const { t } = useLanguage();
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 768);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const reveal = (delay = 0) => ({
    initial: isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 28 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6, delay },
    viewport: { once: true },
  });

  const tools = [
    {
      icon: <FaCalendarAlt />,
      title: t('parents.schedule.title'),
      text: t('parents.schedule.text'),
      btn: t('parents.schedule.btn'),
      href: SCHEDULE_PATH,
    },
    {
      icon: <FaBus />,
      title: t('parents.transport.title'),
      text: t('parents.transport.text'),
      btn: t('parents.transport.btn'),
      href: TRANSPORT_PATH,
    },
  ];

  return (
    <section id="za-roditelje" className="parents section-lg" aria-labelledby="parents-title">
      <div className="container">
        <motion.div className="parents__header" {...reveal()}>
          <span className="parents__header-mark" aria-hidden />
          <p className="parents__kicker">{t('parents.kicker')}</p>
          <h2 id="parents-title" className="parents__title">{t('parents.title')}</h2>
          <p className="parents__subtitle">{t('parents.subtitle')}</p>
        </motion.div>

        <div className="parents__grid">
          {tools.map((tool, i) => (
            <motion.a
              key={tool.href}
              className="parents__card"
              href={tool.href}
              {...reveal(0.08 + i * 0.1)}
            >
              <span className="parents__card-icon" aria-hidden>{tool.icon}</span>
              <h3 className="parents__card-title">{tool.title}</h3>
              <p className="parents__card-text">{tool.text}</p>
              <span className="parents__card-btn">
                {tool.btn} <FaArrowRight aria-hidden />
              </span>
            </motion.a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ParentsTools;
